export function refreshUtmFields(container, delays = [0, 500, 1500]) {
  window.utmFieldsPopulated = false;

  const populate = () => {
    if (!window.initUTMHandling) {
      return;
    }

    const form = container?.querySelector('.formie-lead-form');
    window.initUTMHandling(form || undefined);
  };

  delays.forEach((delay) => {
    if (delay === 0) {
      populate();
      return;
    }

    window.setTimeout(populate, delay);
  });
}

export function debounce(callback, delay) {
  let timeout;

  return (...args) => {
    window.clearTimeout(timeout);
    timeout = window.setTimeout(() => callback(...args), delay);
  };
}
